//src/app/routes/TaxExtensionsRoutes.tsx
import { TaxExtensions } from 'app/features/taxExtensions';
import CreateTaxExtension from 'app/features/taxExtensions/CreateTaxExtension';
import EditTaxExtension from 'app/features/taxExtensions/EditTaxExtension';
import ViewTaxExtension from 'app/features/taxExtensions/ViewTaxExtension';
import { UserRoleEnum } from 'app/services/user';
import React from 'react';
import { Route } from 'react-router-dom';
import { ProtectedRoleRoute } from 'utils/RequireAuth';

export default function TaxExtensionsRoutes() {
  return (
    <>
      <Route path="taxExtensions">
        <Route path="" element={<TaxExtensions />} />
        <Route path=":taxExtensionId">
          <Route path="" element={<ViewTaxExtension />} />
          <Route
            path="edit"
            element={<ProtectedRoleRoute roles={[UserRoleEnum.CLIENT]} />}
          >
            <Route path="" element={<EditTaxExtension />} />
          </Route>
        </Route>

        <Route
          path="create"
          element={<ProtectedRoleRoute roles={[UserRoleEnum.CLIENT]} />}
        >
          <Route path="" element={<CreateTaxExtension />} />
        </Route>
      </Route>
    </>
  );
}
